import Page from 'flow/components/Setting/Page';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectAllQueueMembers,
    selectQueues,
} from 'flow/selectors/queue-selectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import Queue from 'flow/types/Queue';
import { routes } from 'flow/types/routes';
import { TypedMap } from 'flow/types/TypedMap';
import { generatePath, useHistory, useParams } from 'react-router-dom';

const Settings = () => {
    const history = useHistory();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();
    const { i18next } = useAppContext();

    const queues = useAppSelector(selectQueues);
    const allQueueMembers = useAppSelector(selectAllQueueMembers);
    const aiQueues = queues?.filter((queue: TypedMap<Queue>) =>
        allQueueMembers
            .get(queue.get('key'))
            ?.some((member) => member.get('extensionKey') === extensionKey),
    ); // Note from person on git blame: copy+pasted how it's done previously. Should have a selector returning the size.

    return (
        <Page
            header={i18next.t('settings')}
            onClickBack={() => {
                history.push(
                    generatePath(routes['pbx.aicoworker.extensionKey'], {
                        extensionKey,
                    }),
                );
            }}
        >
            <RouteLink
                to={generatePath(
                    routes['pbx.aicoworker.extensionKey.settings.general'],
                    {
                        extensionKey,
                    },
                )}
                state={{ from: history.location.pathname }}
            >
                {i18next.t('ai-coworker.settings.general')}
            </RouteLink>
            <RouteLink
                to={generatePath(
                    routes[
                        'pbx.aicoworker.extensionKey.settings.queuing-system-login'
                    ],
                    {
                        extensionKey: extensionKey,
                    },
                )}
                state={{ from: history.location.pathname }}
                description={aiQueues?.size || 0}
            >
                {i18next.t('ai-coworker.settings.queuing-system-login')}
            </RouteLink>
        </Page>
    );
};

export default Settings;
